// Агрегат подготовки/состояния кампании (CampaignSetup).
// Вынесено из api.ts (Фаза 1, разбор клиента по доменам).

import { request } from "./client";
import { type ClosedBetaReadiness } from "./beta";
import { type CampaignMemberRole, type SetupCampaign } from "./campaign";
import { type CharacterPrivate, type CharacterPublic, type KnowledgeItem } from "./character";
import { type CommandHub } from "./commandHub";
import { type PlayerGender } from "./common";
import { type CampaignContinuity } from "./continuity";
import { type CampaignCycleOverview } from "./cycle";
import { type CampaignInfrastructureOverview } from "./infrastructure";
import { type CampaignInvitation } from "./invitation";
import { type CampaignAvatar, type CampaignAvatarCode, type CampaignAvatarGeneration } from "./media";
import { type CampaignRelationshipOverview } from "./relationship";
import { type CampaignThreatOverview } from "./threat";
import { type World, type WorldSelection } from "./world";

export type SetupStage =
  | "WAITING_FOR_PLAYERS"
  | "COLLECTING_WORLD_PROPOSALS"
  | "WORLD_VOTING"
  | "WORLD_GENERATING"
  | "RANDOM_ROLE_ASSIGNMENT"
  | "PRIVATE_BRIEFING"
  | "READY";
export interface SetupMember {
  campaignMemberId: string;
  userId: string;
  displayName: string;
  username?: string;
  avatarCode: CampaignAvatarCode;
  avatar: CampaignAvatar;
  avatarGeneration: CampaignAvatarGeneration;
  playerGender: PlayerGender;
  isCurrentUser: boolean;
  memberRole: CampaignMemberRole;
  joinedAt: string;
  assignedCharacterId?: string;
  assignedOfficeTitle?: string;
}
export interface CampaignSetup {
  campaign: SetupCampaign;
  canManage: boolean;
  isPlatformAdmin: boolean;
  setupStage: SetupStage;
  members: SetupMember[];
  pendingInvitations: CampaignInvitation[];
  worldSelection: WorldSelection;
  world?: World;
  rolesAssigned: boolean;
  characters: CharacterPublic[];
  myPrivateProfile?: CharacterPrivate;
  visibleKnowledge: KnowledgeItem[];
  continuity: CampaignContinuity;
  threats: CampaignThreatOverview;
  relationships: CampaignRelationshipOverview;
  infrastructure: CampaignInfrastructureOverview;
  betaReadiness: ClosedBetaReadiness;
  cycle: CampaignCycleOverview;
  commandHub?: CommandHub;
}

export const setupApi = {
  campaignSetup: (campaignId: string) =>
    request<CampaignSetup>(`/api/campaigns/${campaignId}/setup`),
};
